"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSpaceOrEnterDown = void 0;
const handleSpaceOrEnterDown = (event, handleClick) => {
  switch (event.key) {
    case 'Enter':
    case 'Space':
    case ' ':
      event.preventDefault();
      handleClick();
      setTimeout(() => {
        event.target.focus();
      }, 300);
      break;
    default:
      break;
  }
};
exports.handleSpaceOrEnterDown = handleSpaceOrEnterDown;